import { render } from "./SittingPosition.vue?vue&type=template&id=1729eb5d&scoped=true"
import script from "./SittingPosition.vue?vue&type=script&lang=js"
export * from "./SittingPosition.vue?vue&type=script&lang=js"

import "./SittingPosition.vue?vue&type=style&index=0&id=1729eb5d&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1729eb5d"]])

export default __exports__